<template lang="pug">
  div
    app-nav
    .row
      .col-sm-2
      .col-sm-8
        h2 Liste de garde
        router-link(type="button" class='btn btn-primary pull-right' :to="{name: 'Garde' , params: { id: listeById.id }}") Retour
        h4 {{moment(listeById.date).format('MMMM - YYYY')}}
 
        div( v-if="loading" class="text-center")
          font-awesome-icon( icon="sync" spin  size="lg" class="my-5")
          br
          span Je cherche les données :-) ...
          br
        transition( name="slide")
          div.table-responsive-lg
            table.table(v-if="listeById.joursByListeId")
              tr(v-for="jour in listeById.joursByListeId.edges" :key="jour.node.id")
                td {{moment(jour.node.date).format('dddd Do MMMM YYYY')}} 
                td
                  select( id="titulaire" name ="titulaire" type="text"  class="form-control" v-on:change="changeTitulaire($event.target.value, jour.node.id)" )
                    option( v-if="jour.node.titulaireByTitulaireId" v-bind:value="jour.node.titulaireByTitulaireId.id") {{jour.node.titulaireByTitulaireId.nom}}
                    option(v-else value=" ")                          
                    option( v-bind:value="titulaire.node.id" v-for="titulaire in allTitulaires.edges") {{titulaire.node.prenom +' '+titulaire.node.nom}}  
      .col-sm-4
        p.lead= sidebar
</template>
<script>
import AppNav from "./AppNav"
import { 
    ALL_TITULAIRES_QUERY,
    ACTIFS_TITULAIRES_QUERY
} from "../constants/graphql"
import {
  GARDE_BY_ID_QUERY,
  JOUR_BY_LISTID,
  UPDATE_JOUR,
  ALL_GARDES
} from "../constants/gardes"
import moment from "moment"
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faSync } from '@fortawesome/free-solid-svg-icons'
moment.locale("fr")
library.add(faSync)
export default {
  name: "GardesEdit",
  components: {
    AppNav,
    FontAwesomeIcon
  },
  data() {
    return {
      loading: false,
      moment: moment,
      listeById: {},
      allJours: {},
      allTitulaires: []
    }
  },
  created () {
    this.fetchData()
  },
  watch: {
    // call again the method if the route changes
    '$route': 'fetchData'
  },
  apollo: {
    allTitulaires: {
      query: ACTIFS_TITULAIRES_QUERY
    }
  },
  methods: {
    async fetchData () {
      console.log('id', this.$route.params.id)
      var self = this
      this.loading = true
      try {
        await new Promise((resolve, reject) => setTimeout(resolve, 3000));
        let result = await this.$apollo.query({
        query: GARDE_BY_ID_QUERY,
        variables: {
          id: parseInt(self.$route.params.id, 10)
          }
        })
        self.loading =  false
        self.listeById = result.data.listeById
      }
      catch(err) {
        console.log(err)
      }   
    },
    changeTitulaire(e, jourId) {
      this.$apollo
        .mutate({
          mutation: UPDATE_JOUR,
          variables: {
            titulaireId: parseInt(e, 10),
            id: jourId
          },
          refetchQueries: [
            {
              query: JOUR_BY_LISTID,
              variables: {
                id: this.listeById.id
              }
            }
          ],
          refetchQueries: [
            {
              query: ALL_GARDES
            }
          ]
        })
        .then(data => {})
        .catch(error => {
          console.error(error)
        })
    }
  }
}
</script>
<style scoped>
.slide-enter {
}
.slide-enter-active {
  animation: slide-in 1s ease-out forwards;
}

@keyframes slide-in {
  from {
    transform: translateX(20px);
  }
  to {
    transform: translateX(0);
  }
}
</style>



// WEBPACK FOOTER //
// gardesEdit.vue?593ae770